import Swiper, { Navigation, Autoplay } from "swiper";

const slider = new Swiper(".careers-testimonials-carousel .slider-content", {
  modules: [Navigation, Autoplay],
  spaceBetween: 0,
  slidesPerView: 1,
  loop: true,
  direction: "horizontal",
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 5000,
  },
});

document.body.addEventListener("click", function (e) {
  if (e.target && (e.target.matches(".next") || e.target.matches(".prev")) && e.target.parentNode.matches(".photo")) {
    e.preventDefault();
    const t = e.target;
    if (t.matches(".next")) {
      slider.slideNext();
    }
    if (t.matches(".prev")) {
      slider.slidePrev();
    }
  }
});
